/**
 * Polyfills required by Angular.
 */

// Load `$localize` onto the global scope - used if i18n tags appear in Angular templates
import '@angular/localize/init';

// Zone.js is required by Angular for change detection
import 'zone.js';

/***************************************************************************************************
 * required for dayjs to support older browsers esp wrt DateTimeFormat
 * can be removed after hanko migration. since we don't support older browsers after.
 */
import '@formatjs/intl-datetimeformat/polyfill.js';
import '@formatjs/intl-datetimeformat/locale-data/en.js';
import '@formatjs/intl-datetimeformat/locale-data/de.js';
import '@formatjs/intl-datetimeformat/locale-data/fr.js';
import '@formatjs/intl-datetimeformat/locale-data/it.js';
import '@formatjs/intl-datetimeformat/add-all-tz.js';

// Required for some Node.js packages to work in the browser
(window as any).global = window;
